var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownloadWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 9.16667V11.6667H1.66667V9.16667H0V11.6667C0 12.5833 0.75 13.3333 1.66667 13.3333H11.6667C12.5833 13.3333 13.3333 12.5833 13.3333 11.6667V9.16667H11.6667ZM10.8333 5.83333L9.65833 4.65833L7.5 6.80833V0H5.83333V6.80833L3.675 4.65833L2.5 5.83333L6.66667 10L10.8333 5.83333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownloadWhite);
export default __webpack_public_path__ + "static/media/icon-download-white.90d774d88cedaafc96b24d1155730027.svg";
export { ForwardRef as ReactComponent };